// Henüz okuyamayan çocuklar için sesli okuma (readAloud.nl.ts). Türkçe sürüm.
export const readAloudTr = {
    button: 'Sesli oku',
    stop: 'Okumayı durdur',
    task: '{task} görevini sesli oku',
};
//# sourceMappingURL=readAloud.tr.js.map